import React from "react";
import "./index.pc.css";
function getDefault(module) {
  return module.default || module;
}

function castStyle(value) {
  var tov = typeof value;
  if (tov === "object" || tov !== "string" || !value) return value;
  return value.trim().split(";").reduce(function (obj, keyValue) {
    var kvp = keyValue.split(":");
    var key = kvp[0];
    var value = kvp[1];
    if (!value || value === "undefined") return obj;
    var trimmedValue = value.trim();
    if (trimmedValue === "undefined" || !trimmedValue) return obj;
    obj[key.trim()] = trimmedValue;
    return obj;
  }, {});
}

export const classNames = {

};

var LineProgressBar = React.memo(React.forwardRef(function LineProgressBar(props, ref) {
  return React.createElement("div", {
    "className": "_75c77dc0 _3621f341 _pub-3621f341" + (props["large"] ? " " + "_3621f341_large _pub-3621f341_large large" : ""),
    "ref": ref,
  }, null)
}));
export { LineProgressBar };


